import { css } from '@/styled-system/css';

export const authPageStack = css({
  display: 'grid',
  gap: 'loose',
});

export const authPageHeader = css({
  display: 'grid',
  gap: 'loose',
});

export const authCardColumn = css({
  width: '100%',
  // eslint-disable-next-line hotpads/no-magic-numbers -- established auth card width shared across sign-in and password workflows
  maxWidth: '440px',
  marginInline: 'auto',
});

export const cardStack = css({
  display: 'grid',
  gap: 'default',
});

export const cardBody = css({
  display: 'grid',
  gap: 'default',
});

export const workflowCardHeader = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  color: 'text.neutral',
});

export const workflowCardHeaderIcon = css({
  color: 'brand.primary',
  flexShrink: 0,
});

export const formStack = css({
  display: 'grid',
  gap: 'default',
});

export const actionRow = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '150',
  alignItems: 'stretch',
  sm: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export const inlineActionRow = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '150',
  alignItems: 'center',
});

export const mutedText = css({
  color: 'text.subtle',
});

export const strongText = css({
  fontWeight: 'bold',
});

export const statusHeader = css({
  display: 'flex',
  gap: '150',
  alignItems: 'center',
});

export const statusIconSuccess = css({
  color: 'brand.primary',
  flexShrink: 0,
});

export const statusIconError = css({
  color: 'error',
  flexShrink: 0,
});

export const statusMessage = css({
  display: 'grid',
  gap: 'tighter',
});

export const subscriptionList = css({
  display: 'grid',
  gap: 'tighter',
  margin: 0,
  paddingLeft: 'loose',
});

export const simpleList = css({
  display: 'grid',
  gap: 'tighter',
  margin: 0,
  paddingLeft: 'loose',
});

export const centeredStack = css({
  display: 'grid',
  gap: 'default',
  justifyItems: 'center',
  textAlign: 'center',
});

export const scoreBadge = css({
  width: '1000',
  height: '1000',
  borderRadius: 'ellipse',
  background: 'brand.primary',
  color: 'white',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 'heading-sm',
  lineHeight: 'heading-sm',
  fontWeight: 'bold',
});

export const suggestionsList = css({
  display: 'grid',
  gap: 'micro.default',
  listStyle: 'none',
  margin: 0,
  padding: 'tighter',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.neutral',
  borderRadius: 'md',
  background: 'bg.softest',
});

export const suggestionButton = css({
  width: '100%',
  borderWidth: 'none',
  background: 'transparent',
  color: 'text.neutral',
  textAlign: 'left',
  paddingInline: 'tighter',
  paddingBlock: '150',
  borderRadius: 'sm',
  cursor: 'pointer',
  font: 'inherit',
  _hover: {
    background: 'bg.neutral',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
  },
});

export const ratingGroup = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  gap: 'tighter',
});

export const tagGroup = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'tighter',
});

export const characterCount = css({
  color: 'text.subtle',
  fontSize: 'body-xs',
  lineHeight: 'body-xs',
  textAlign: 'right',
});

export const resultCardGrid = css({
  display: 'grid',
  gap: 'default',
  md: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
});

export const optOutShell = css({
  minHeight: 'breakpoint-sm',
  display: 'grid',
  placeItems: 'center',
  padding: 'layout.loose',
  background: 'bg.neutral',
});
